import React from "react";
//import '../App.css';
import NavigationBar from '../components/nav';
import {withRouter} from 'react-router-dom';
//import {Form,Container,Tabs,Tab,TabContainer,Row,Col,Button} from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Demographics from "./form/demographic";
import Clinical_data from "./form/clinicaldata";
import configuration from '../conf.json';
import DataForm from "../components/Data-form";

class  Patients extends React.Component{



    render() {

        return(
            <>

                    <NavigationBar page='new-patient'/>
                    <Container >




                                        <DataForm  patient={'new'}/>
                                      






                    </Container>
                <br/>
                <br/>
            </>
        )
    }
}
export default Patients;